import type PaginatedResponse from '@/types/PaginatedResponse'
import { http } from '../plugins/http'
import type { AxiosResponse } from 'axios'

import type DataResponse from '@/types/DataResponse'
import type MessageResponse from '@/types/MessageResponse'
import type SaleTerminal from '@/types/SaleTerminal'
import ModelService from '@/contracts/ModelService'

export default class SaleTerminalService extends ModelService<SaleTerminal> {
  async index(page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<SaleTerminal>>> {
    return await http.get<PaginatedResponse<SaleTerminal>>(
      `/api/v1/office/sale-terminals?page=${page}&${filters}&per_page=${per_page}`,
    )
  }

  async show(id: string) {
    return await http.get<DataResponse<SaleTerminal>>(`/api/v1/office/sale-terminals/${id}`)
  }

  async update(id: string, model: SaleTerminal) {
    const data = {
      ...model,
    }

    return await http.put<DataResponse<SaleTerminal>>(
      `/api/v1/office/sale-terminals/${id}`,
      data,
    )
  }

  async destroy(model: SaleTerminal) {
    return await http.delete<MessageResponse>(
      `/api/v1/office/sale-terminals/${model.id}`,
    )
  }

  async store(model: SaleTerminal) {
    return await http.post<DataResponse<SaleTerminal>>(
      `/api/v1/office/sale-terminals`,
      model,
    )
  }
}
